import { getJquery } from '../js/util'

export default {
	init() {
		const $ = getJquery()

		hideProtectionRow()

		$(document.body).on('updated_cart_totals', hideProtectionRow)
	},
}

/** hide shipping protection fee in table bc we're displaying it ourselves */
function hideProtectionRow() {
	const feeRows = document.querySelectorAll('tr.fee')
	for (let row of feeRows) {
		if (row.innerText.includes('Shipping Protection')) {
			row.style.display = 'none'
		}
	}
}
